// extracted by mini-css-extract-plugin
export default {"rating":"QK-z","numberOfStars":"RK-z","count":"SK-z","barGraphSpacing":"TK-z","barGraph":"UK-z"};